export default {"src":"/_next/static/media/no_image.d5c549bd.svg","height":433,"width":668,"blurWidth":0,"blurHeight":0};